/**
 * @author Madhu Sudhan
 * @Date: 2022-11-17 11:30:11
 * @Last Modified by: madhusudhan
 * @Last Modified time: 2022-11-21 18:30:11
 */
const NsdlColumns = [
  {
    title: 'Beneficiary Name',
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: 'Account Type',
    dataIndex: 'account_type',
    key: 'account_type',
  },
  {
    title: 'Bank account No',
    dataIndex: 'account_number',
    key: 'account_number',
  },
  {
    title: 'Ifsc Code',
    dataIndex: 'ifsc_code',
    key: 'ifsc_code',
  },
];

const YblColumns = [
  {
    title: 'Beneficiary Id',
    dataIndex: 'beneficiary_id',
    key: 'beneficiary_id',
  },
  {
    title: 'Beneficiary Name',
    dataIndex: 'beneficiary_name',
    key: 'beneficiary_name',
  },
  {
    title: 'Bank Account No',
    dataIndex: 'bank_account_no',
    key: 'bank_account_no',
  },
  {
    title: 'IFSC Code',
    dataIndex: 'ifsc_code',
    key: 'ifsc_code',
  },
];

const FUND_TRANSFER_CONSTANTS = Object.freeze({
  COMPLETE_OTP_VERIFICATION: 'Please Verify the OTP to update the Limits',
  CONTACT_CUSTOMER_CARE: 'Not your number ? Contact customer service',
  YES_BANK_IMPS: 'yessbank_imps',
  YES_BANK_IMPS_VALIDATION_MESSAGE: 'Please Validate to Perform IMPS Transaction.',
  YES_BANK_DELETE: 'yessbank_delete_beneficary',
  YES_BANK_DELETE_VALIDATION_MESSAGE: 'Please Validate to delete the beneficiary.',
  YES_BANK_REPLACE_CARD_MESSAGE: 'Please Validate to Replace the Card.',
  YES_BANK_DRIVER_SALARY: 'yessbank_driver_salary',
  YES_BANK_DRIVER_SALARY_VALIDATION_MESSAGE: 'Please Validate',
});

export {
  NsdlColumns, YblColumns, FUND_TRANSFER_CONSTANTS,
};



// WEBPACK FOOTER //
// client/containers/FundTransfer/constants.js